var H = Object.defineProperty;
var L = (e, t, s) => t in e ? H(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s;
var D = (e, t, s) => (L(e, typeof t != "symbol" ? t + "" : t, s), s), A = (e, t, s) => {
  if (!t.has(e))
    throw TypeError("Cannot " + s);
};
var r = (e, t, s) => (A(e, t, "read from private field"), s ? s.call(e) : t.get(e)), a = (e, t, s) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, s);
}, o = (e, t, s, n) => (A(e, t, "write to private field"), n ? n.call(e, s) : t.set(e, s), s);
var u = (e, t, s) => (A(e, t, "access private method"), s);
var c, v, h, w, m, k, N;
class S {
  constructor(t, s, n) {
    a(this, k);
    a(this, c, void 0);
    a(this, v, void 0);
    a(this, h, void 0);
    a(this, w, void 0);
    a(this, m, !1);
    o(this, h, t), s === null ? o(this, c, {}) : o(this, c, s), o(this, w, n);
  }
  get() {
    return r(this, c);
  }
  set(t) {
    return t ? (typeof t == "object" ? o(this, c, { ...r(this, c), ...t }) : o(this, c, t), r(this, m) || (o(this, m, !0), this.render(), o(this, m, !1)), !0) : !1;
  }
  render() {
    r(this, c) && (u(this, k, N).call(this).innerHTML = r(this, w).call(this, r(this, c), this.set.bind(this)));
  }
  create() {
    return `<div class="${r(this, h)}"></div>`;
  }
}
c = new WeakMap(), v = new WeakMap(), h = new WeakMap(), w = new WeakMap(), m = new WeakMap(), k = new WeakSet(), N = function() {
  if (r(this, v))
    return r(this, v);
  const t = document.querySelector(`.${r(this, h)}`);
  if (!t)
    throw Error("element not found");
  return t;
};
const j = "_details_kvzm5_1", C = "_album_kvzm5_8", I = "_details_text_kvzm5_14", J = "_head_kvzm5_19", O = "_rib_kvzm5_19", $ = {
  details: j,
  album: C,
  details_text: I,
  head: J,
  rib: O
};
function R(e) {
  return `
    <div class="${$.details}">
      ${e.cover && `<img class="${$.album}" src="${e.cover}"/>`}
      <div class="${$.details_text}">
        <p class="${$.head}">${e.track}</p>
        <p class="${$.rib}">${e.artists} – ${e.album}</p>
      </div>
    </div>
  `;
}
function E(e) {
  return e.milliseconds ? `<span ${e.active && 'id="time"'} class="${e.className}">${B(e.milliseconds)}</span>` : "";
}
function B(e) {
  const t = Math.floor(e / 1e3 / 60), s = Math.floor(e / 1e3 % 60);
  let n = "";
  return s < 10 && (n = "0"), `${t}:${n}${s}`;
}
const G = "_progress_ele8o_1", K = "_progress_bar_ele8o_9", Q = "_progress_timestamp_ele8o_33", T = {
  progress: G,
  progress_bar: K,
  progress_timestamp: Q
};
function U(e) {
  return !e.duration || !e.progress ? "" : `
    <div class="${T.progress}">
      ${E({
    className: T.progress_timestamp,
    milliseconds: e.progress,
    active: !0
  })}
      <progress
        id="progress"
        class="${T.progress_bar}"
        value="${e.progress / e.duration * 100}"
        max="100"
      >
          ${V(e.progress, e.duration)}%
      </progress>
      ${E({
    className: T.progress_timestamp,
    milliseconds: e.duration
  })}
    </div>
  `;
}
function V(e, t) {
  return Math.floor(e / t * 100);
}
var d, g, f, b, _, l, x, q, p, P, y, z, M, F;
class X extends HTMLElement {
  constructor() {
    super();
    a(this, x);
    a(this, p);
    a(this, y);
    a(this, M);
    a(this, d, void 0);
    a(this, g, void 0);
    a(this, f, !1);
    a(this, b, 0);
    a(this, _, 0);
    a(this, l, void 0);
    D(this, "observedAttributes", ["src"]);
    o(this, d, new S("details", null, R)), o(this, g, new S("progress", null, U)), this.render(r(this, d), r(this, g));
  }
  connectedCallback() {
    u(this, x, q).call(this);
  }
  render(...s) {
    const [n, i] = s;
    this.innerHTML = `
      ${n.create()}
      ${i.create()}
    `;
  }
  get src() {
    return this.getAttribute("src");
  }
  set src(s) {
    s ? this.setAttribute("src", s) : this.removeAttribute("src");
  }
}
d = new WeakMap(), g = new WeakMap(), f = new WeakMap(), b = new WeakMap(), _ = new WeakMap(), l = new WeakMap(), x = new WeakSet(), q = function() {
  if (!this.src)
    return;
  const s = new EventSource(this.src);
  s.onmessage = (n) => {
    const i = JSON.parse(n.data);
    r(this, d).set({
      track: i.track,
      album: i.album,
      artists: i.artists,
      cover: i.cover,
      preview: i.preview
    }), r(this, g).set({
      progress: i.progress,
      duration: i.duration,
      isPlaying: i.playing
    }), o(this, b, new Date(i.time).getTime() - i.progress), o(this, f, i.playing), o(this, _, i.duration), u(this, y, z).call(this), r(this, f) && !i.destroy && o(this, l, window.requestAnimationFrame(r(this, p, P)));
  };
}, p = new WeakSet(), P = function() {
  return () => {
    const n = (/* @__PURE__ */ new Date()).getTime() - r(this, b);
    n > r(this, _) && u(this, y, z).call(this);
    const i = n / r(this, _) * 100;
    window.progress && (window.progress.value = i, window.progress.innerText = `${i}%`), window.time && (window.time.innerText = u(this, M, F).call(this, n)), r(this, f) && i < 100 && window.requestAnimationFrame(r(this, p, P));
  };
}, y = new WeakSet(), z = function() {
  r(this, l) && (window.cancelAnimationFrame(r(this, l)), o(this, l, void 0));
}, M = new WeakSet(), F = function(s) {
  if (!s)
    return "0:00";
  const n = Math.floor(s / (1e3 * 60)), i = Math.floor(s % (1e3 * 60) / 1e3);
  return `${n}:${i < 10 ? `0${i}` : i}`;
};
export {
  X as default
};
